import {
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  TOUCHPOINTS_RESET,
  TOUCHPOINTS_SET,
  TOUCHPOINT_GROUPS_SET,
  TOUCHPOINT_REMOVE,
  TOUCHPOINT_SET,
  TOUCHPOINT_TYPES_SET,
} from './actionTypes';
import {
  IDeleteTouchpointAction,
  IFailedSyncAction,
  ISetTouchpointAction,
  ISetTouchpointGroupsAction,
  ISetTouchpointTypesAction,
  ISetTouchpointsAction,
  ITouchpoint,
  ITouchpointsAction,
  ITouchpointsState,
} from './types';

export const initialState = {
  error: null,
  loaded: false,
  touchpoints: [],
  touchpointGroups: [],
  touchpointTypes: [],
  syncing: 0, // @TODO use object for sync state to be able to differenciate between different actions
};

export const reducer = (
  state: ITouchpointsState = initialState,
  action: ITouchpointsAction
): ITouchpointsState => {
  switch (action.type) {
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload };
    case SYNC_FINISHED:
      return { ...state, syncing: state.syncing - 1 };
    case SYNC_INITIATED:
      return { ...state, error: null, syncing: state.syncing + 1 };
    case TOUCHPOINT_REMOVE:
      return {
        ...state,
        touchpoints: state.touchpoints.filter(
          (touchpoint: ITouchpoint) =>
            touchpoint.id !== (action as IDeleteTouchpointAction).payload.id
        ),
      };
    case TOUCHPOINT_SET:
      const touchpointIndex = state.touchpoints.findIndex(
        (touchpoint) => touchpoint.id === (action as ISetTouchpointAction).payload.id
      );
      return {
        ...state,
        touchpoints: [
          ...state.touchpoints.slice(0, touchpointIndex),
          (action as ISetTouchpointAction).payload,
          ...state.touchpoints.slice(touchpointIndex + 1),
        ],
      };
    case TOUCHPOINT_GROUPS_SET:
      return {
        ...state,
        touchpointGroups: (action as ISetTouchpointGroupsAction).payload,
      };
    case TOUCHPOINTS_RESET:
      return {
        ...state,
        loaded: false,
        touchpoints: [],
      };
    case TOUCHPOINTS_SET:
      return {
        ...state,
        loaded: true,
        touchpoints: (action as ISetTouchpointsAction).payload,
      };
    case TOUCHPOINT_TYPES_SET:
      return {
        ...state,
        touchpointTypes: (action as ISetTouchpointTypesAction).payload,
      };
    default:
      return state;
  }
};
